<template>
    <div>
        <v-btn round large color="primary" @click="addUser">Add User</v-btn>
        <v-dialog
                v-model="dialog"
                width="600"
        >
            <editDialog
                    :input-mode="inputMode"
                    :user-data="userToEdit"
                    :roles="roles"
                    @closeDialog="dialog=false"
                    @userAdded="pushUser"
                    @userEdited="userEdited"
            ></editDialog>
        </v-dialog>
        <v-dialog
                v-model="deleteDialog"
                width="500"
        >
            <delete-dialog :title="`${userToDelete.first_name}`" @onDelete="deleteUser(userToDelete.id)"></delete-dialog>
        </v-dialog>


        <v-layout wrap>
            <v-flex
                    md3
                    v-for="user in users"
                    :key="user.id"
            >
                <div class="card-curvey text-xs-center" primary-title>
                    <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                    dark
                                    icon
                                    v-on="on"
                            >
                                <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                        </template>

                        <v-list>
                            <v-list-tile-title class="pointer mb-3" @click="editUser(user)"><v-icon>edit</v-icon><span class="mr-2 ml-2 ">Edit</span></v-list-tile-title>
                            <v-list-tile-title class="pointer" @click="openDeleteDialog(user)"><v-icon>delete</v-icon><span class="mr-2 ml-2">Delete</span></v-list-tile-title>
                        </v-list>
                    </v-menu>
                    <div class="bot-info">
                        <span class="icon-wrapper">
                            <v-icon>mdi-account-outline</v-icon>
                        </span>
                        <div class="px-3">
                            <h3 class="mb-0">{{user.first_name}}</h3>
                            <p class="text-truncate">{{user.email}}</p>
                            <v-chip class="ma-2">
                                {{ getRoleName(user.role_id) }}
                            </v-chip>
                        </div>
                    </div>
                </div>

            </v-flex>
        </v-layout>


        <!--        <div class="card-curvey pa-0">-->

        <!--            <v-data-table-->
        <!--                    :headers="headers"-->
        <!--                    :items="users"-->
        <!--                    :hide-actions="true"-->
        <!--            >-->
        <!--                <template v-slot:items="props">-->
        <!--                    <td>{{ props.item.first_name }}</td>-->
        <!--                    <td class="">{{ props.item.last_name }}</td>-->
        <!--                    <td class="">{{ props.item.email }}</td>-->
        <!--                    <td class="justify-center layout px-0">-->
        <!--                        &lt;!&ndash;                    <v-icon&ndash;&gt;-->
        <!--                        &lt;!&ndash;                            small&ndash;&gt;-->
        <!--                        &lt;!&ndash;                            class="mr-2"&ndash;&gt;-->
        <!--                        &lt;!&ndash;                            @click="editUser(props.item)"&ndash;&gt;-->
        <!--                        &lt;!&ndash;                    >&ndash;&gt;-->
        <!--                        &lt;!&ndash;                        edit&ndash;&gt;-->
        <!--                        &lt;!&ndash;                    </v-icon>&ndash;&gt;-->
        <!--                        &lt;!&ndash;                    <v-icon&ndash;&gt;-->
        <!--                        &lt;!&ndash;                            small&ndash;&gt;-->
        <!--                        &lt;!&ndash;                            @click="openDeleteDialog(props.item)"&ndash;&gt;-->
        <!--                        &lt;!&ndash;                    >&ndash;&gt;-->
        <!--                        &lt;!&ndash;                        delete&ndash;&gt;-->
        <!--                        &lt;!&ndash;                    </v-icon>&ndash;&gt;-->
        <!--                    </td>-->
        <!--                </template>-->
        <!--            </v-data-table>-->
        <!--        </div>-->
    </div>

</template>

<script>
    import common from "../../utils/common";
    import editDialog from './addOrEdit'
    import deleteDialog from "../common/deleteDialog";

    export default {
        name: "table",
        components: {
            deleteDialog,
            editDialog
        },
        data() {
            return {
                inputMode: '',
                userToEdit: {},
                userToDelete: {},
                dialog: false,
                deleteDialog: false,
                users: [],
                roles: [],
                headers: [
                    {
                        text: 'First Name',
                        align: 'left',
                        sortable: false,
                        value: 'first_name'
                    },
                    {
                        text: 'Last Name',
                        align: 'left',
                        sortable: false,
                        value: 'last_name'
                    },
                    {
                        text: 'Email',
                        align: 'left',
                        sortable: false,
                        value: 'email'
                    },

                    // { text: 'Actions', value: 'name', sortable: false, align: 'center', }
                ],
            }
        },
        mounted() {
            this.getUsers()
            this.getRoles()
        },
        methods: {
            getUsers() {
                this.$http.get('/users/')
                    .then(response => {
                        this.users = response.data
                        // console.log(this.users, ' users')
                    })
                    .catch(error => {
                        if (error.response.status === 401) {
                            common.logOut()
                        }
                    })
            },
            getRoles() {
                this.$http.get('/constants').then(response=>{
                    this.roles = response.data.roles
                }).catch(error => {
                    if (error.response.status === 401) {
                        common.logOut()
                    }
                })
            },
            getRoleName(id){
                const role = this.roles.find(role => {
                    return role.value == id
                })
                return role && role.title || ''
            },
            editUser(user) {
                this.userToEdit = user
                this.inputMode = 'edit'
                this.dialog = true
            },
            openDeleteDialog(user) {
                this.userToDelete = user
                this.deleteDialog = true
            },
            deleteUser(userid) {
                let index = -1
                let that = this
                this.deleteDialog = false
                this.$http.delete(`/users/${userid}`)
                    .then(response => {
                        // debugger
                        index = _.findIndex(that.users, o => {
                            return o.id === userid
                        });
                        if (index !== -1) {
                            that.users.splice(index, 1)
                            // console.log(that.users)
                        }
                    })
                    .catch(error => {

                    })
            },
            addUser() {
                this.userToEdit = {
                    corporate_id: this.$store.state.user.userData.corporate_id
                }
                this.inputMode = 'add'
                this.dialog = true
            },
            pushUser(user) {
                const userToPush = _.cloneDeep(user)
                this.users.push(userToPush)
            },
            userEdited(user) {
                let index = _.findIndex(this.users, o => {
                    return o.id === this.user.id
                })
                if (index !== -1) {
                    this.users[index] = _.cloneDeep(user)
                }
            }
        },

    }
</script>

<style lang="scss" scoped>
    .v-menu__content {
        padding: 1rem;
        background: #FFFFFF;
    }

    table.v-table tbody td {
        padding: 24px 24px;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.54)
    }

    .card-curvey {
        height: 190px;
        width: 100%;
        position: relative;
        border-radius: 10px;
        padding: 16px 0px;

        .v-btn.v-btn--icon {
            color: #bcbcbc;
            position: absolute;
            top: 5px;
            right: 5px;
            padding: 0;

        }

        .bot-info {
            span.icon-wrapper {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 60px;
                height: 60px;
                border-radius: 50%;
                background-color: #0d1633;
                margin: 0 auto 0.5rem;

                i {
                    color: #FFFFFF;
                    font-size: 30px;
                }
            }

            h3 {
                color: #0d1633;
            }

            p {

                margin-bottom: 0.5rem;
            }

            .v-chip {
                background-color: rgba(0, 0, 0, 0.15);
                color: #000000;
                padding: 0 1rem;
            }
        }
    }
.pointer{
    cursor: pointer;
}
</style>
